<template>
    <div class="c-box p-5">
        <div class="c-box__header mb-5">
            <div class="c-box__title text-center text-uppercase">
                Forgot Password
            </div>
        </div>
        <div v-if="reset_sent === true" class="alert alert-info">
            <p>A request to reset your password has been sent.</p>
            <p>If your email exists in our database, you will receive instructions on how to reset your password.</p>
            <router-link :to="{ name: 'login.main', params: { company_id: c_id } }" class="c-btn c-btn--success">
                Sign In
            </router-link>
        </div>
        <template v-else>
            <div class="c-form">
                <form @submit.prevent="forgot_pass">
                    <div class="row form-group c-form__group">
                        <label for="cId" class="col-12 c-form__label">Panel Id</label>

                        <div class="col-12">
                            <b-form-input id="cId" placeholder="" v-model.trim="c_id"></b-form-input>
                        </div>
                    </div>
                    <div class="row form-group c-form__group">
                        <label for="inputEmail1" class="col-12 c-form__label">Email</label>

                        <div class="col-12">
                            <b-form-input id="inputEmail1" placeholder="" v-model.trim="email"></b-form-input>
                        </div>
                    </div>
                    <div class="row form-group c-form__group">
                        <div class="col-md-offset-2 col-12">
                            <button v-if="forgot_pass_in_progress === false" class="c-btn c-btn--success" type="submit">
                                Reset password
                            </button>
                            <button v-else disabled class="c-btn c-btn-default">
                                Loading...
                            </button>
                            <router-link :to="{ name: 'login.main', params: { company_id: c_id } }" class="c-btn c-btn-default">
                                Sign In
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <forgot-password-main-ccs-modal></forgot-password-main-ccs-modal>
    </div>
</template>

<script>
import CcsModal from "@/components/CcsModal.vue";

export default {
    metaInfo: {
        title: "Forgot Password"
    },

    components: {
        ForgotPasswordMainCcsModal: CcsModal
    },

    mounted() {},

    props: {
        company_id: {
            type: Number,
            default: undefined
        }
    },

    data: function() {
        return {
            forgot_pass_in_progress: false,
            reset_sent: false,

            email: "",
            c_id: this.company_id
        };
    },

    watch: {},

    computed: {},

    methods: {
        forgot_pass: function() {
            if (
                this.c_id === undefined ||
                this.c_id === "" ||
                Number.isInteger(parseInt(this.c_id)) === false
            ) {
                this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                    type: "error",
                    title: "Error while attempting to login",
                    text: "Please fill in the Panel ID field",
                    buttons: [
                        {
                            title: "Close",
                            default: false // Will be triggered by default if 'Enter' pressed.
                        }
                    ]
                });

                return;
            }

            let payload = {
                email: this.email,
                company_id: this.c_id
            };

            this.forgot_pass_in_progress = true;
            this.$store.dispatch("user/ForgotPassword", payload).then(
                (success_data) => {
                    this.forgot_pass_in_progress = false;
                    this.reset_sent = true;
                },
                (error_data) => {
                    this.forgot_pass_in_progress = false;
                    console.log(error_data);

                    if(parseInt(error_data.return_status) === 13203) // ACCOUNT NOT ACTIVATED
                    {
                      this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                        type: "warning",
                        title: "Could not send reset password request",
                        text: error_data.return_text,
                        buttons: [
                          {
                            title: "Resend activation email",
                            class: "c-btn c-btn--warning c-btn--primary",
                            handler: () => {
                              this.resend_invite_email();
                            },
                          }
                        ]
                      });
                    }
                    else
                    {
                      this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                        type: "warning",
                        title: "Could not send reset password request",
                        text: error_data.return_text,
                        buttons: [
                          {
                            title: "Close",
                            default: true // Will be triggered by default if 'Enter' pressed.
                          }
                        ]
                      });
                    }
                    return;
                }
            );
        },

      resend_invite_email: function() {
        if (this.c_id === undefined || this.c_id === "" || Number.isInteger(parseInt(this.c_id)) === false) {
          this.$modal.hide("forgot-password-main-ccs-modal-dialog");
          this.$modal.show("forgot-password-main-ccs-modal-dialog", {
            type: "error",
            title: "Error while attempting to send activation e-mail",
            text: "Please fill in the Panel ID field",
            buttons: [
              {
                title: "Close",
                default: false // Will be triggered by default if 'Enter' pressed.
              }
            ]
          });

          return;
        }

        let payload = {
          company_id: this.c_id,
          username: this.email,
        };

        this.$store.dispatch("user/ResendActivateEmail", payload).then(
            (success_data) => {
              console.log('success data', success_data);
              this.$modal.hide("forgot-password-main-ccs-modal-dialog");
              this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                type: "success",
                title: "Activation email successfully sent",
                text: "Please check your email for the link to activate your account",
                buttons: [
                  {
                    title: "Close",
                    default: true // Will be triggered by default if 'Enter' pressed.
                  }
                ]
              });
            },
            (error_data) => {
              console.log(error_data);
              this.$modal.hide("forgot-password-main-ccs-modal-dialog");
              this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                type: "warning",
                title: "Could not send activation email",
                text: error_data,
                buttons: [
                  {
                    title: "Close",
                    default: true // Will be triggered by default if 'Enter' pressed.
                  }
                ]
              });
              return;
            }
        );
      }

    }
};
</script>
